import { getLocale } from "../runtime";

const sv_iconcountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Land`
};

const iconcountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_iconcountry(inputs)
	return "iconCountry";
};

export { iconcountry as "iconCountry" };